import Vue from 'vue';
import VueRouter from 'vue-router';
import i18n from './i18n';

Vue.use(VueRouter);

const Deactivate = () => import("./views/Deactivate");
const Home = () => import("./views/Home");
const AboutRoomPlus = () => import("./views/AboutRoomPlus");

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/:lang(en|ru|de|ar|id|it|sr|th|tr|fr|zh-s|zh-t|ja|bs|cs|ko)?/profiles',
      component: { render: h => h('router-view') },
      children: [
        { path: '', redirect: 'home' },
        { path: 'deactivate', component: Deactivate },
        {
          path: 'home',
          component: Home,
          children: [
            { path: '', redirect: 'notifications' }, //temporary, todo: remove
            { path: 'notifications', component: () => import("./views/home/Notifications") },
          ],
        },
        {
          path: 'about/room-plus',
          component: AboutRoomPlus,
        },
      ]
    }
  ],

  scrollBehavior () {
    return new Promise(resolve => {
      this.app.$root.$once('scrollTo', (selector) => {
        resolve({ selector: selector })
      })
    })
  }
});

router.beforeEach((to, from, next) => {
  i18n.locale = to.query.lang || to.params.lang || 'en';
  next();
});

export default router;
